define('bindingHandlers/dateRangePicker2',[
    'lib/lodash4',
    'moment',
    'lib/knockout',
    'jquery',

    'util/errorCallbackFactory',

    'bindingHandlers/util/datePickerUtil',
    'bindingHandlers/include',
    'lib/bootstrap-datetimepicker'
], function (
    _,
    moment,
    ko,
    $,

    errorCallbackFactory,

    datePickerUtil

    ) {
    "use strict";

    var $commandContainer = $('<div class="date-range-command-container"></div>')[0];

    var startDateObservable = ko.observable();
    var endDateObservable = ko.observable();
    var commandContainerIncludeValueAccessor = ko.observable();

    var START_CALENDAR = '<div class="calendar-container startDatePicker left-picker"></div>';
    var END_CALENDAR = '<div class="calendar-container endDatePicker right-picker"></div>';

    var validDateRange = function (startDate, endDate, rangeLimit) {
        var maxEndDate = moment(startDate).add(rangeLimit, 'days');
        return maxEndDate.isAfter(endDate) || maxEndDate.isSame(endDate);
    };

    var validTimeRange = function (startDate, endDate) {
        return moment(startDate).isBefore(endDate) || moment(startDate).isSame(endDate);
    };

    var createDateRangeCommandDiv = function(element, settings, rangeLimited, allBindings, viewModel, bindingContext){

        $(element).append($commandContainer);

        var getRanges = function (item) {
            var startDate = item.value[0];
            var endDate = item.value[1];
            startDateObservable(ko.i18n.formatDate(startDate));
            endDateObservable(ko.i18n.formatDate(endDate));
        };

        commandContainerIncludeValueAccessor({
            name: "templates/widgets/dateRangePickerCommand",
            data: {
                ranges: settings.ranges,
                startDate: startDateObservable,
                endDate: endDateObservable,
                applyRange: getRanges,
                hasCommandButtons: settings.hasCommandButtons,
                rangeLimited: rangeLimited
            }
        });

        ko.bindingHandlers.include.init.call(this, $commandContainer, commandContainerIncludeValueAccessor, allBindings, viewModel, bindingContext);
        ko.bindingHandlers.include.update.call(this, $commandContainer, commandContainerIncludeValueAccessor, allBindings, viewModel, bindingContext);
    };

    /**
     * Date Time Range Picker (Bootstrap)
     *
     * This binding handler will allow for a more robust approach to picking a date, month, year, time range etc...
     * Uses Bootstrap 3, dependant on Moment and jQuery.
     *
     * The option "format" can be used to show / hide certain areas from selection. For instance if the format of MMMM YYYY
     *  is selected then only the year and month will be selectable.
     *
     *
     * Options:
     *          timeZone {boolean} = default false; set to true this will apply the client's timezone to moment; uses moment's formatting
     *          isTodayMaxDate {boolean} = default false; when set to true uses today as max date
     *          useClientLocale {boolean} = default false; when set to true used the client locale value to pass on to moment
     *          format {string} = will determine which components are shown
     *          viewMode {string} = will determine which view should be displayed when the picker is rendered
     *                          i.e. months will start with months being shown, years will show years, etc...
     *          tooltipPlacement = default "default", can be set to top or bottom to keep toolbar in place; default will slide the
     *                 toolbar up or down
     *
     * sample:
     *
     * Options specific range picker only:
     *          rangeLimited: (default - false) will limit range to only 31 days
     *          showCommandDiv: (default - true) shows the div that will display the From/ To dates, the range selector, and command buttons
     *          customRanges: (default - Array) array of custom canned ranges
     *          hasCommandButtons: (default - shown) when set to false, it will hide the command buttons (apply and cancel);
     *                              useful for using the range picker in a popover that may have an apply or cancel already
     *          hasIntervalSelection: (default - shown) when set to false it will not generate the interval selection
     *          hasRangeDisplay: (default - shown) when set to false, the range inputs will not be shown
     *
     * BASIC USAGE:
     * <div class="date-range-picker2" data-bind= "dateRangePicker2: {
     *                          value: This would be a date in the form of a string, Date, moment or null
     *                          options: {
     *                              useClientLocale: true <---- MUST be set to true for dateRangePicker2
     *                          }
     *                    }"></div>
     *
     * EXAMPLE USAGE WITH CUSTOM RANGES :
     * <div class="date-range-picker2" data-bind= "dateRangePicker2: {
     *                      value: dateRangeObservable,
     *                      options: {
     *                          customRanges: someArray,
     *                          useClientLocale: true,
     *                          isTodayMaxDate: true,
     *                          tooltipPlacement: 'bottom'
     *                          }
                            customRanges: someArray
     *                      }"></div>
     *
     * EXAMPLE USAGE WITHIN POPOVER AND RANGE LIMIT :
     * <div class="date-range-picker2" data-bind= "dateRangePicker2: {
     *                      value: dateRangeObservable,
     *                      options: {
     *                          customRanges: someArray,
     *                          useClientLocale: true,
     *                          isTodayMaxDate: true,
     *                          tooltipPlacement: 'bottom',
     *                          showCommandDiv: false
     *                          },
     *                      popover: popoverObject
     *                      rangeLimit: 31               <--- should be number of days
     *                      }"></div>
     */

    ko.bindingHandlers.dateRangePicker2 = {
        init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            var bindingData = valueAccessor() || {};
            var $element = $(element);
            var rangeData, commandSettings, rangeLimit;

            try {
                if(bindingData.popover) {
                    //The binding handler for the dateRangePicker2 is within a popover. Using bindingContext to get the
                    // parent we can manipulate the popover button
                    var popoverValueAccessor = bindingData.popover;
                    popoverValueAccessor.disableApply = ko.observable(false);
                    popoverValueAccessor.overRangeLimit = ko.observable(false);
                    popoverValueAccessor.invalidTimeRange = ko.observable(false);
                }

                //Set range limit if one exists
                if(bindingData.rangeLimit) {
                    if(_.isNumber(bindingData.rangeLimit)){
                        rangeLimit = bindingData.rangeLimit;
                        bindingData.overRangeLimit = ko.observable(false);
                    } else {
                        throw "rangeLimit is not a valid number";
                    }
                }

                //Set the range template to use the established ranges in datePickerUtil
                if(bindingData.customRanges) {
                    if(_.isArray(bindingData.customRanges)) {
                        //pass in custom ranges
                        rangeData = {
                            options: {
                                customRanges: bindingData.customRanges
                            }
                        };
                    } else {
                        errorCallbackFactory.createCallback({"namespace": "widget.dateRangePicker2.invalidCustomRangeArray"});
                    }

                }  else {
                    //populate the dropdown with default values
                    rangeData = {
                        options: {
                            intervalSelection: true
                        }
                    };
                }

                rangeData.options.hasCommandButtons = bindingData.hasCommandButtons;

                //Process the range options
                commandSettings = datePickerUtil.processOptions(rangeData);

                //Set inline to true; consumer should handle popover of BH
                bindingData.options.inline = true;

                //create two pickers inline
                $element.append(START_CALENDAR);
                $element.append(END_CALENDAR);

                var options = datePickerUtil.processOptions(bindingData);

                //The consumer must set the showCommandDiv option to false to hide it
                if(bindingData.options.showCommandDiv !== false){
                    createDateRangeCommandDiv(element, commandSettings, rangeLimit, allBindings, viewModel, bindingContext);
                }

                // Left Picker will represent start date; right picker will be end date
                var $startDatePicker = $('.startDatePicker');
                var $endDatePicker = $('.endDatePicker');

                //init pickers with options
                $startDatePicker.datetimepicker(options);
                $endDatePicker.datetimepicker(options);

                //when a user changes the start date, update the view model
                ko.utils.registerEventHandler($startDatePicker, "dp.change", function (event) {
                    var value = valueAccessor().value;
                    var endDate = $('.endDatePicker').data().DateTimePicker.date();
                    //Get the start of day selected:  to get the correct value I had to put the event date into
                    // moment and select the start of the day.
                    if(event.date && endDate) {
                        var startDate = moment(event.date).toISOString();

                        if(moment(endDate.toISOString()).diff(moment(startDate), 'days') < 0) {
                            endDate = moment(startDate);
                            $('.endDatePicker').data().DateTimePicker.date(endDate.toISOString());
                        }

                        var timePicker = false;
                        if (_.has(valueAccessor(), 'options.format')) {
                            timePicker = _.includes(valueAccessor().options.format, 'h') || _.includes(valueAccessor().options.format, 'm') || _.includes(valueAccessor().options.format, 's');
                        }

                        if(bindingData.rangeLimit) {
                            if(validDateRange(startDate, endDate.toISOString(), bindingData.rangeLimit)) {
                                bindingData.overRangeLimit(false);
                                if(popoverValueAccessor) {
                                    popoverValueAccessor.overRangeLimit(false);
                                }
                            } else {
                                bindingData.overRangeLimit(true);
                                if(popoverValueAccessor) {
                                    popoverValueAccessor.overRangeLimit(true);
                                    popoverValueAccessor.disableApply(true);
                                }
                            }
                        }

                        if (timePicker) {
                            if (validTimeRange(startDate, endDate.toISOString())) {
                                popoverValueAccessor.invalidTimeRange(false);
                            } else {
                                popoverValueAccessor.invalidTimeRange(true);
                            }
                        }

                        if (popoverValueAccessor.invalidTimeRange() || popoverValueAccessor.overRangeLimit()) {
                            popoverValueAccessor.disableApply(true);
                        } else {
                            popoverValueAccessor.disableApply(false);
                        }

                        if (ko.isObservable(value)) {
                            if (event.date !== null && !(event.date instanceof Date)) {
                                //As above, we are taking the event date and getting the end of day value for the previous day
                                value(startDate + '/' + endDate.toISOString());
                            } else {
                                value(event.date);
                            }
                        }
                        // Set the value for the range input
                        startDateObservable(ko.i18n.formatDate(event.date));
                        endDateObservable(ko.i18n.formatDate(endDate));

                    } else {
                        value();
                        startDateObservable();
                        endDateObservable();
                    }
                 });

                //when a user changes the end date, update the view model
                ko.utils.registerEventHandler($endDatePicker, "dp.change", function (event) {
                    var value = valueAccessor().value;
                    var startDate = $('.startDatePicker').data().DateTimePicker.date();

                    if(event.date && startDate) {
                        var endDate = moment(event.date).toISOString();

                        if(moment(endDate).diff(moment(startDate.toISOString()), 'days') < 0) {
                            startDate = moment(endDate);
                            $('.startDatePicker').data().DateTimePicker.date(startDate.toISOString());
                        }

                        var timePicker = false;
                        if (_.has(valueAccessor(), 'options.format')) {
                            timePicker = _.includes(valueAccessor().options.format, 'h') || _.includes(valueAccessor().options.format, 'm') || _.includes(valueAccessor().options.format, 's');
                        }

                        //Limit range consumer set limit
                        if(bindingData.rangeLimit) {
                            if(validDateRange(startDate.toISOString(), endDate, bindingData.rangeLimit)) {
                                bindingData.overRangeLimit(false);
                                if(popoverValueAccessor) {
                                    popoverValueAccessor.overRangeLimit(false);
                                }
                            } else {
                                bindingData.overRangeLimit(true);
                                if(popoverValueAccessor) {
                                    popoverValueAccessor.overRangeLimit(true);
                                }
                            }
                        }

                        if (timePicker) {
                            if (validTimeRange(startDate.toISOString(), endDate)) {
                                popoverValueAccessor.invalidTimeRange(false);
                            } else {
                                popoverValueAccessor.invalidTimeRange(true);
                            }
                        }

                        if (popoverValueAccessor.invalidTimeRange() || popoverValueAccessor.overRangeLimit()) {
                            popoverValueAccessor.disableApply(true);
                        } else {
                            popoverValueAccessor.disableApply(false);
                        }

                        if (ko.isObservable(value)) {
                            if (event.date !== null && !(event.date instanceof Date)) {
                                if (timePicker) {
                                    value(startDate.toISOString() + '/' + event.date.toISOString());
                                } else {
                                    value(startDate.toISOString() + '/' + moment(event.date).endOf('day').toISOString());
                                }
                            } else {
                                value(event.date);
                            }
                        }
                            startDateObservable(ko.i18n.formatDate(startDate));
                            endDateObservable(ko.i18n.formatDate(event.date));
                    } else {
                        value();
                        startDateObservable();
                        endDateObservable();
                    }
                });

                //Clean up
                ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
                    var startDatePicker = $(startDatePicker).data("DateTimePicker");
                    var endDatePicker = $(endDatePicker).data("DateTimePicker");
                    if (startDatePicker && endDatePicker) {
                        startDatePicker.destroy();
                        endDatePicker.destroy();
                    }
                });
            } catch (error) {
                errorCallbackFactory.createCallback({"namespace" : "widget.dateRangePicker2.error"}, error);
            }
        }
    };
});

